<template>
  <div
    id="app"
    class="min-h-screen bg-gradient-to-br"
  >
    <header class="header" style="z-index: 999;">
      <nav
        class="container mx-auto px-4 py-4 flex items-center justify-between"
      >
       
        <div class="flex items-center">
          <img src="./assets/logo.png"  alt="Logo" class="logo mr-5 h-12" />
          <router-link to="/" class="title-logo font-bold text-white">
            MQ System
          </router-link>
        </div>
        <div class="space-x-4">
          <router-link
            v-for="(link, index) in navLinks"
            :key="index"
            :to="link.path"
            class="text-white hover:text-grey transition duration-300"
          >
            {{ link.name }}
          </router-link>
        </div>
      </nav>
    </header>
    <main class="container mx-auto py-8">
      <div class="watermark"> </div>
      <router-view class="body"></router-view>
    </main>
    <!--<footer class="footer text-white py-6">
      <div class="container mx-auto px-4 text-center">
        <p>© 2023 MQ System. All rights reserved.</p>
        <p class="mt-2 text-gray-200">Empowering education through advanced evaluation tools</p>
      </div>
    </footer>-->
    <!-- modal for staff to choose staff view or student view -->
    <div
      class="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50"
      v-if="isSelectShow == true"
    >
    
      <div class="bg-white p-4 rounded-lg">
        <h2 class="text-l font-semibold text-center">
          Please select your mode:
        </h2>
        <div class="justify-center mt-4">
          <button
            @click="switchToStaff"
            style="width: 180px"
            class="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-light"
          >
            Staff Mode
          </button>
        </div>
        <div class="mt-2">
          <button
            @click="switchToStudent"
            style="width: 180px"
            class="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-light"
          >
            Student Mode
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { userApi } from "@/api/userManagement";
export default {
  name: "App",
  data() {
    return {
      navLinks: [
        { name: "Home", path: "/" },
        { name: "Data", path: "/data" },
        { name: "Surveys", path: "/surveys" },
        { name: "Email Templates", path: "/email-templates" },
        { name: "Admin", path: "/dashboard" },
        { name: "Reports", path: "/reports" },
        { name: "Logout", path: "/Logout" },
      ],
      role: "",
      currentUser: null,
      isSelectShow: false,
    };
  },
  methods: {
    ...mapActions(["fetchAllData"]),
    ...mapActions("auth", [
      "setUser",
      "setUserRole",
      "setUserDepartment",
      "setUserSchool",
    ]),
    async initializeUserData() {
      // This is just an example, replace with your actual authentication logic
      let userRole = ""; //'school_admin' or 'department_admin' or 'super_admin'
      let userDepartment = "";
      let userSchool = "";

      let user = await userApi.getProfile();

      if (user == null) {
        alert(
          "You don't have permission to access this page, please contact admin."
        );
        localStorage.clear();
        window.location = "https://sso.xjtlu.edu.cn/logout";
        return;
      } else {
        if (user.role == "admin") {
          userRole = "admin";
        } else if (user.role == "school_admin") {
          userRole = "school_admin";
          userSchool = user.manages;
        } else if (user.role == "department_admin") {
          userRole = "department_admin";
          userDepartment = user.manages;
        }

        this.role = user.role;

        this.setUserRole(userRole);
        this.setUserDepartment(userDepartment);
        this.setUserSchool(userSchool);

        if (user.role == "Student") {
          if (user.manages == "Staff") {
            //let yes = confirm('You are a staff, do you want to switch to staff view?')
            
            this.isSelectShow = true;
            this.currentUser = user;
          } else {
            this.navLinks = [{ name: "Logout", path: "/Logout" }];
            if ("/student" !== this.$route.path) this.$router.push("/student");
          }
        } else {
          //alert(user.role)
          if (user.role == "supervisor" || user.role == 'Staff' || user.groups.length > 0)
            this.navLinks = [
              { name: "Home", path: "/" },
              { name: "Reports", path: "/reports" },
              { name: "Logout", path: "/Logout" },
            ];
          if (user.role == 'department_admin')
            this.navLinks = [
              { name: "Home", path: "/" },
              { name: "Data", path: "/data" },
              { name: "Surveys", path: "/surveys" },
              { name: "Email Templates", path: "/email-templates" },
              { name: "Reports", path: "/reports" },
              { name: "Logout", path: "/Logout" },
            ];
          if ("/" !== this.$route.path && this.$route.path != "/student/")
            this.$router.push("/");
        }
        this.setUser(user);
      }
    },
    switchToStudent() {
      this.isSelectShow = false;
      this.setUser(this.currentUser);
      this.navLinks = [{ name: "Logout", path: "/Logout" }];
      if ("/student" !== this.$route.path) this.$router.push("/student");
    },
    switchToStaff() {
      this.isSelectShow = false;
      this.currentUser.role = "Staff";
      this.setUser(this.currentUser);
      this.navLinks = [
        { name: "Home", path: "/" },
        { name: "Reports", path: "/reports" },
        { name: "Logout", path: "/Logout" },
      ];
      if ("/" !== this.$route.path) this.$router.push("/");
    },
  },
  async created() {
    await this.initializeUserData();
    if (
      this.role == "admin" ||
      this.role == "school_admin" ||
      this.role == "department_admin" ||
      this.role == 'Staff' ||
      this.role == 'supervisor'
    )
      await this.fetchAllData();
  },
};
</script>


<style>
.body {
  font-size: 14px;
}

.revert {
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(298deg) brightness(102%) contrast(102%);
}
.header {
  background-color: rgb(1, 5, 68);
  height: 70px;
}

.bg-primary {
  background-color: rgb(24, 93, 169);
}

.bg-primary-dark {
  background-color: rgb(1, 5, 68);
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

.title-logo {
    font-size: 24px;
  }

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .logo {
    display: none;
  }
  .title-logo {
    font-size: 14px;
  }
}
.watermark {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("https://mymq.xjtlu.edu.cn/images/watermark.png") repeat center center;
  background-size: auto;
  pointer-events: none;  /* 让水印不可点击 */
  filter: grayscale(100%);
}
</style>
